import { Component,Input, OnInit , ViewChild, ElementRef} from '@angular/core';
import { ResponseData } from 'src/app/service/model/response.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartConfiguration, ChartType } from 'chart.js';
import { ChartService } from '../../service/chart.service';
import { CategoryPopupComponent } from '../../chart-popup/category-popup/category-popup.component';
@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  @ViewChild('doughnutCanvasCategory') doughnutCanvasCategory!: ElementRef;
    chartCategory: any;
  @Input() item!: ResponseData;
  currentYear=new Date("YYYY");
// public barChartOptions:any = {
//     scaleShowVerticalLines: false,
//     responsive: true
//   };

  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 8,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };
    chartData: number[]=[];
    public doughnutChartLabels: string[] = [];
    public doughnutChartData:number[]=[]; 
    public doughnutChartType: ChartType = 'doughnut';
    public doughnutColor: string[] = [];
   
    public barChartType:string = 'bar';
    //public barChartLegend:boolean = true;

    public barChartColors:Array<any> = [
    {
      backgroundColor: '#74acac',
      borderColor: '#346d68',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    }
  ];
  constructor(private modalService: NgbModal,private chartService:ChartService) { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
   this.CreateChart();
}
  CreateChart()
  {
    for (let i = 0; i < this.item.data.dashboardCategoriesChart.length; i++) {
          
            this.doughnutChartLabels.push(this.item.data.dashboardCategoriesChart[i].serviceName)
            this.doughnutChartData.push(this.item.data.dashboardCategoriesChart[i].totalCount);
          }
          this.doughnutColor=this.chartService.generateColors(this.doughnutChartData.length);//['#457b2aff','#7a9f6aff'];
          //this.renderChart(this.chartCategory,this.doughnutCanvasCategory,this.doughnutChartLabels,this.doughnutChartData,this.doughnutColor);
          this.chartService.renderChart(this.chartCategory,this.doughnutCanvasCategory,this.doughnutChartLabels,this.doughnutChartData,this.doughnutColor);
          //Income Per Quarter Doughnut Chart
 
  }

  OpenPopUp()
  {  
          const modalRef = this.modalService.open(CategoryPopupComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
          (modalRef.componentInstance as CategoryPopupComponent).defaultChartData=this.item.data.dashboardCategoriesChart;
          
            modalRef.result.then((result) => {
              //console.log(result);
            });
        
  } 
}
